import { Action } from 'redux';
import { RequestStatus } from './request';

// Action Types
export const SETTING_PASSWORD = 'SETTING_PASSWORD';
export const SET_PASSWORD_FAILED = 'SET_PASSWORD_FAILED';
export const PASSWORD_SET = 'PASSWORD_SET';

// Action Interfaces
export interface ISettingPasswordAction extends Action {}
export interface ISetPasswordFailedAction extends Action {
  payload: string | undefined;
}
export interface IPasswordSetAction extends Action {}

// Type of all Action Interfaces
export type SetPasswordActionTypes =
  | ISetPasswordFailedAction
  | ISettingPasswordAction
  | IPasswordSetAction;

// State Interface
export interface ISetPasswordState {
  error?: string;
  status: RequestStatus;
}
